import { HeightRule, Table, TableRow, WidthType, TableLayoutType } from "docx";
import Calculations from "../../../helpers/calculations";
import {
  tableCellMain,
  tableCellMainRight,
  tableCellWithColSpan,
  tableCellWithRowSpanBorders,
} from "./tableCell";

export const conclusionTableBrandenburg = (schueler, klausur) => {
  const { abzug, roundedAfb, gesamtpunkte, gesamtnote, sumAfb1Bis3Anteil } =
    new Calculations(schueler, klausur).results.Brandenburg;
  return new Table({
    layout: TableLayoutType.FIXED,
    columnWidths: [2800, 1800, 1800, 1800, 1800],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Bereiche"),
          tableCellMain("Punkte"),
          tableCellMain("Ergebnis"),
          tableCellMain("Gesamtpunkte"),
          tableCellMain("Gesamtnote"),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Aufgabenbearbeitung"),
          tableCellMainRight(`${sumAfb1Bis3Anteil.toFixed(2)}`),
          tableCellMainRight(`${roundedAfb}`),
          tableCellWithRowSpanBorders(`${gesamtpunkte}`, 3),
          tableCellWithRowSpanBorders(`${gesamtnote}`, 3),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Sprachverwendung"),
          tableCellMainRight(`Abzug`),
          tableCellMainRight(`${abzug}`),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [tableCellWithColSpan("erreichte Gesamtpunktzahl", 3)],
      }),
    ],
  });
};
